import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";

export default function NotFound() {
  return (
    <SiteLayout>
      <div className="w-full px-4 md:px-8 py-24 md:py-32 flex flex-col items-center text-center">
        <span className="font-heading font-bold text-7xl md:text-9xl text-accent-500">
          404
        </span>
        <h1 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mt-4">
          页面走丢了
        </h1>
        <p className="text-sm md:text-base text-foreground-500 mt-3 max-w-md">
          你访问的页面不存在或已被移除，不如回到首页或去分类页发现新的漫画吧。
        </p>
        <div className="flex flex-wrap items-center justify-center gap-3 mt-7">
          <Link
            to="/"
            className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-home-5-line"></i>
            返回首页
          </Link>
          <Link
            to="/category"
            className="inline-flex items-center gap-2 h-11 px-6 rounded-md border border-background-300 text-foreground-700 text-sm font-medium hover:bg-background-100 transition-colors whitespace-nowrap"
          >
            <i className="ri-apps-2-line"></i>
            浏览漫画分类
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}